import type { LatLng, Route, RouteStep, RoutingProvider } from "../types";

/** Decode a Google polyline string into an array of LatLng. */
function decodePolyline(encoded: string): LatLng[] {
  const coords: LatLng[] = [];
  let index = 0;
  let lat = 0;
  let lng = 0;

  while (index < encoded.length) {
    let shift = 0;
    let result = 0;
    let byte: number;

    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    const dlat = (result & 1) ? ~(result >> 1) : result >> 1;
    lat += dlat;

    shift = 0;
    result = 0;

    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    const dlng = (result & 1) ? ~(result >> 1) : result >> 1;
    lng += dlng;

    coords.push({ lat: lat / 1e5, lng: lng / 1e5 });
  }

  return coords;
}

export const osrmProvider: RoutingProvider = {
  name: "OSRM",

  async route(from: LatLng, to: LatLng): Promise<Route> {
    const url =
      `https://router.project-osrm.org/route/v1/driving/` +
      `${from.lng},${from.lat};${to.lng},${to.lat}` +
      `?overview=full&geometries=polyline&steps=true`;

    const res = await fetch(url);
    if (!res.ok) throw new Error(`OSRM error: ${res.status}`);

    const data = await res.json();
    if (data.code !== "Ok" || !data.routes?.length) {
      throw new Error(`No route found (${data.code})`);
    }

    const r = data.routes[0];

    const steps: RouteStep[] = (r.steps ?? []).map((s: { distance: number; duration: number; end_location: [number, number] }) => ({
      distanceM: s.distance,
      durationS: s.duration,
      location:  s.end_location,
    }));

    return {
      geometry:  decodePolyline(r.geometry),
      distanceM: r.distance,
      durationS: r.duration,
      steps:     steps.length ? steps : undefined,
    };
  },
};
